import { setAuthTokenProvider } from '@pulse/utils/request';

import { useAuthStore } from '~/store/auth';

/**
 * Valet shares services with Concierge through the pulse library — media signing is the one in use
 * today — but reaches the gateway directly rather than through Concierge's Nitro proxy. Those calls
 * therefore carry neither the front-door header nor a bearer token, and are refused once the
 * Concierge access guards enforce.
 *
 * Registered as a provider rather than a value so the token is read per request and a refresh is
 * picked up. Concierge registers nothing, so its customer traffic is unchanged.
 */
export default defineNuxtPlugin(() => {
  setAuthTokenProvider(() => useAuthStore().accessToken);
});
